import { Browser } from "@capacitor/browser";
import { useNavigate } from "react-router-dom";

import { Button } from "atoms/button/Button";

interface RetailProductTrackShippingButtonProps {
  disabled?: boolean;
  shipmentTrackingUrl?: string | null;
}

export const RetailProductScanInStoreButton = ({
  disabled,
  orderId,
  pickupData,
}: {
  disabled?: boolean;
  orderId?: string;
  pickupData?: {
    retailProductVariantId: string;
    productId: string;
    quantity: number;
    platformLocationId: string;
    isFromMembership: boolean;
  };
}) => {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent event bubbling to parent div
    if (orderId) {
      navigate("/scan-redeem-retail-products-order", {
        state: { orderId },
      });
    } else {
      navigate("/scan-pickup-retail-products-item", {
        state: pickupData,
      });
    }
  };

  return (
    <Button
      fullWidth
      disabled={disabled}
      onClick={handleClick}
      size="xsmall"
      style="secondarySolid"
    >
      {disabled ? "Picked up" : "Scan to pick up"}
    </Button>
  );
};

export const RetailProductTrackShippingButton = ({
  disabled,
  shipmentTrackingUrl,
}: RetailProductTrackShippingButtonProps) => {
  const handleClick = async () => {
    const url = shipmentTrackingUrl ?? "https://track.myrepeat.app/";
    await Browser.open({ url });
  };

  return (
    <Button
      fullWidth
      disabled={disabled || !shipmentTrackingUrl}
      onClick={handleClick}
      size="xsmall"
      style="secondarySolid"
    >
      Track Order
    </Button>
  );
};
